import React from 'react'

interface IProps {
  refresh: () => void;
  isRefresh?: boolean;
}

class Refresh extends React.PureComponent<IProps> {
  static defaultProps = {
    refresh: () => { },
  }
  private adRef = React.createRef<HTMLDivElement>();
  private first: boolean = true;

  componentDidMount() {
    const { refresh, isRefresh } = this.props;
    let ref = this.adRef.current;

    try {
      let io = new IntersectionObserver(
        entries => {
          if (this.first && !isRefresh) {
            if (entries[0].isIntersecting) {
              refresh();
              this.first = false
            }
          }
        }, {
        threshold: [1],
      });
      if (ref) {
        io.observe(ref);
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const { children } = this.props;

    return (
      <div ref={this.adRef}>
        {children}
      </div>
    );
  }
}

export default Refresh;